import Sunny16BaseService from '@/services/Sunny16BaseService'

import type {
  CartStorefrontDto,
  CheckoutDetailsDto
} from '@VelocitySquared/sunny16-commerce-dataobjects/storefront'
import { OrderAdjustmentRequestDto } from '@VelocitySquared/sunny16-commerce-dataobjects/storefront'

class Sunny16CommerceOrderService extends Sunny16BaseService {
  constructor() {
    super(import.meta.env.VITE_SUNNY_16_STOREFRONT_API_BASE_URL, 'Sunny16CommerceOrderService')
  }
  async upsertOrder(
    cartId: string,
    checkoutDetails: CheckoutDetailsDto
  ): Promise<CartStorefrontDto> {
    try {
      const response = await this.axiosInstance.post(`/order/${cartId}`, checkoutDetails)
      return response.data
    } catch (error) {
      throw error
    }
  }
  async adjustOrder(cartId: string, adjustmentAmount: number): Promise<CartStorefrontDto> {
    const adjustmentRequest: OrderAdjustmentRequestDto = new OrderAdjustmentRequestDto()
    adjustmentRequest.cartId = cartId
    adjustmentRequest.adjustmentAmount = adjustmentAmount
    try {
      const response = await this.axiosInstance.post(`/order/${cartId}/adjust`, adjustmentRequest)
      return response.data
    } catch (error) {
      throw error
    }
  }
}

export default Sunny16CommerceOrderService
